"use client";

import { useInfront } from "@/context/infront-context";
import { useEffect, useRef } from "react";

type TechnicalChartProps = {
  instrument: {
    feed: number;
    ticker: string;
  };
  periods: string[];
  defaultPeriod?: string;
};

const ID = "technical-chart";

const TechnicalChart = (props: TechnicalChartProps) => {
  const { isReady, load } = useInfront();
  const widgetRef = useRef<any>(null);

  useEffect(() => {
    let active = true;

    load?.(["core", "highstock", "heikinashi", "hollowcandlestick"]).then(() => {
      if (!isReady || !active) return;

      widgetRef.current?.destroy();
      widgetRef.current = null;

      const widgetOptions = new window.Infront.ChartWidgetOptions();

      widgetOptions.instruments = [props.instrument];

      widgetOptions.topToolbar = {
        periodMenu: true,
        chartTypeMenu: true,
        newCompareMenu: true,
        fullScreenButton: true,
      };

      widgetOptions.selectablePeriods = props.periods;
      widgetOptions.defaultPeriod = props.defaultPeriod || "1D";
      widgetOptions.chartType = "baseline";
      widgetOptions.showPrevClose = false;
      widgetOptions.legendItemClick = "remove";
      widgetOptions.showTooltip = false;

      widgetOptions.topToolbarLabels = {
        periodMenu: {
          isIcon: false,
          value: new window.Infront.Observable("Period"),
        },
        chartTypeMenu: {
          isIcon: false,
          value: new window.Infront.Observable("Diagramtyp"),
        },
        newCompareMenu: {
          isIcon: false,
          value: new window.Infront.Observable("Jämför"),
        },
      };

      widgetOptions.selectableNewCompare = {
        list: [],
      };

      widgetRef.current = window.infront.chartWidget(`#${ID}`, widgetOptions);
    });

    return () => {
      active = false;
      widgetRef.current?.destroy();
      widgetRef.current = null;
    };
  // Jämför primitiver istället för objekt-referensen för att undvika onödiga re-initialiseringar
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady, props.instrument.feed, props.instrument.ticker, props.periods, props.defaultPeriod]);

  return <div className="card h-[360px]" id={ID} />;
};

export default TechnicalChart;
